module.exports = __webpack_public_path__ + "img/tag3.26db14c8.png";